import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import NoData from "../../atoms/NoData";
import Button from "../../atoms/Button";
import { MdDelete, MdEdit } from "react-icons/md";
import useModal from "../../../hooks/useModal";
import Modal from "../../molecules/Modal";
import { toast } from "react-toastify";
import ModalConfirm from "../../molecules/ModalConfirm";
import { FaEye } from "react-icons/fa";
import moment from "moment";
import ModalEditAnuncio from "./ModalEditAnuncio";
import { DELETE_ANNOUNCEMENT } from "../../../api/apiAnuncios";
import { useSession } from "../../../context/SessionContext";

const TableAnuncios = ({ data, loading, refetch }) => {
    const [anuncio, setAnuncio] = useState();
    const { open, close, isOpen } = useModal();
    const { open:open2, close:close2, isOpen:isOpen2 } = useModal();
    const { open:open3, close:close3, isOpen:isOpen3 } = useModal();
    const { user } = useSession();
    const [expandedRow, setExpandedRow] = useState(null);

    const handleOpenSee = (anuncio) =>{
        setAnuncio(anuncio);
        open2();
    };

    const handleOpenEdit = (anuncio) =>{
        setAnuncio(anuncio);
        open();
    };

    const handleOpenDelete = (anuncio) => {
        setAnuncio(anuncio);
        open3();
    };

    const handleDelete = async () => {
        try {
            await DELETE_ANNOUNCEMENT(anuncio?.id);
            toast.success("Eliminado correctamente");
            refetch();
            close3();
        } catch (error) {
            toast.error("Error al eliminar");
            console.error(error);
        }
    };

    const columns = [
        {name: "Titulo", selector: row => row.title},
        {name: "Ver", cell: row => (
            <div className="flex flex-row space-x-2">
                <Button text={<FaEye size={22}/> } bgColor="orange" width="w-10" onClick={() => handleOpenSee(row)} />
                {user?.role === "Admin" &&
                    <div className="flex flex-row space-x-2">
                        <Button text={<MdEdit size={22}/> } bgColor="blue" width="w-10" onClick={() => handleOpenEdit(row)} />
                        <Button text={<MdDelete size={22}/> } bgColor="red" width="w-10" onClick={() => handleOpenDelete(row)} />
                    </div>
                }
            </div>
        )},
    ];

    const columnsResponsive = [
        {name: "Titulo", selector: row => row.title},
    ];

    const ExpandedComponent = ({ data }) => (
        <div className="flex flex-row justify-around">
            <Button text={<FaEye size={22}/> } bgColor="orange" width="w-10" onClick={() => handleOpenSee(data)} />
            {user?.role === "Admin" &&
                <Button text={<MdEdit size={22}/> } bgColor="blue" width="w-10" onClick={() => handleOpenEdit(data)} />
            }
            {user?.role === "Admin" &&
                <Button text={<MdDelete size={22}/> } bgColor="red" width="w-10" onClick={() => handleOpenDelete(data)} />
            }
        </div>
    );

    const conditionalRowStyles = [
        {
            when: row => row?.id === expandedRow?.id,
            style: { backgroundColor: '#f3f4f6', },
        },
    ];

    return(
        <div>
            <div className="block md:hidden">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columnsResponsive}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    expandableRowExpanded={(row) => row?.id === expandedRow?.id}
                    onRowExpandToggled={(expanded, row) => {
                        setExpandedRow(expanded ? row : null);
                    }}
                    conditionalRowStyles={conditionalRowStyles}
                />
            </div>
            <div className="hidden md:block">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columns}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                />
            </div>
            {isOpen &&
                <Modal title="Editar aviso" onClose={close}>
                    <ModalEditAnuncio anuncio={anuncio} onClose={close} refetch={refetch} />
                </Modal>
            }
            {isOpen2 &&
                <Modal title={anuncio?.title} onClose={close2}>
                    <div className="w-full flex flex-col justify-center items-center">
                        <p className="text-gray-600 mb-2 text-justify">{anuncio.description}</p>
                        <p className="text-sm text-gray-400">
                            Publicado el {moment(anuncio.createdAt).format("DD/MM/YY")}
                        </p>
                    </div>
                </Modal>
            }
            {isOpen3 &&
                <ModalConfirm onClose={close3} onConfirm={handleDelete} eliminacion />
            }
        </div>
    );
};

export default TableAnuncios;